import { ChangeDetectionStrategy, Component, computed, inject, input, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ITariffButtonBlok } from './tariff-button.model';
import { TariffStore } from '../../../../tariff';
import { GtmService } from '@seven1/angular/gtm';
import { TailwindService } from '@seven1/angular-storyblok/tailwind';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-tariff-button',
    imports: [MatIconModule, NgClass],
    providers: [],
    templateUrl: './tariff-button.component.html',
    styleUrls: ['./tariff-button.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[class]': 'getDisplayClasses()',
    },
})
export class TariffButtonComponent {
    tariffStore = inject(TariffStore);
    private _gtmService = inject(GtmService);
    private _tailwind = inject(TailwindService);

    block = input.required<ITariffButtonBlok>();

    getOuterClasses = computed<string[]>(() => {
        return ['block', 'cursor-pointer', ...this._tailwind.getSpacingClasses(this.block())];
    });

    getDisplayClasses = computed<string[]>(() => {
        return this._tailwind.getDisplayClasses(this.block());
    });

    click() {
        const block = this.block();
        this.tariffStore.tariff = block.variant;
        switch (block.variant) {
            case 'family':
                this._gtmService.logEvent(
                    block.gtm_click_family_event_name || 'button_tariff_family_click',
                    'tariff_selection_change',
                    'click',
                    undefined,
                    {
                        tariff: this.tariffStore.tariff,
                        size: this.tariffStore.size,
                    }
                );
                break;
            case 'single':
                this._gtmService.logEvent(
                    block.gtm_click_single_event_name || 'button_tariff_single_click',
                    'tariff_selection_change',
                    'click',
                    undefined,
                    {
                        tariff: this.tariffStore.tariff,
                        size: this.tariffStore.size,
                    }
                );
                break;
        }
    }
}
